"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var Utils = __importStar(require("../../utils"));
var notification_wrapper_1 = __importDefault(require("./notification-wrapper"));
var useStyles = Utils.makeStyles(function (theme) { return ({
    root: {
        '& > *': {
            marginBottom: theme.spacing(2)
        }
    },
    floating: {
        left: '50%',
        position: 'fixed',
        top: '100px',
        transform: 'translateX(-50%)',
        width: '80%',
        zIndex: 9000
    }
}); });
var BannerWrapper = function (_a) {
    var notifications = _a.notifications, _b = _a.floating, floating = _b === void 0 ? false : _b;
    var classes = useStyles();
    return (react_1["default"].createElement("div", { className: classes.root + " " + (floating ? classes.floating : '') }, notifications.map(function (_a, i) {
        var text = _a.text, confirmationType = _a.confirmationType, onClose = _a.onClose;
        return (react_1["default"].createElement(notification_wrapper_1["default"], { key: "notification-" + i, floating: false, confirmationType: confirmationType, onClose: onClose },
            react_1["default"].createElement(react_1["default"].Fragment, null, text)));
    })));
};
exports["default"] = BannerWrapper;
